import styled from "@emotion/styled";
import React, { useState, useRef } from "react";
import PropTypes from "prop-types";

import Button from "~/components/buttons/Button";
import FriendlyCaptcha from "~/components/FriendlyCaptcha";

import UserContent from "~/components/UserContent";

import { sanitizeAndParseHTML } from "~/utilities/helpers";

const TermsOfUseWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Terms = styled(UserContent)`
    max-width: 100%;
`;

const ButtonWrapper = styled.div`
    padding-top: 15px;
`;

const TermsOfUse = ({
    startDownload,
    setDocTermsStorage,
    terms,
    closeModal,
}) => {
    const [showCaptcha, setShowCaptcha] = useState(false);
    const newTabRef = useRef(null);

    const onCaptchaComplete = (token) => {
        startDownload(token, newTabRef.current);
        setDocTermsStorage();
        setShowCaptcha(false);
        if (closeModal) {
            closeModal();
        }
    };

    return (
        <TermsOfUseWrapper>
            <Terms>{sanitizeAndParseHTML(terms)}</Terms>
            <ButtonWrapper>
                <Button
                    disabled={showCaptcha}
                    color="purple"
                    small
                    onClick={() => {
                        newTabRef.current = window.open(
                            "/preparing-download",
                            "_blank",
                        );
                        setShowCaptcha(true);
                    }}
                >
                    I Accept
                </Button>
            </ButtonWrapper>
            {showCaptcha ? (
                <FriendlyCaptcha
                    onComplete={onCaptchaComplete}
                    startMode="auto"
                />
            ) : null}
        </TermsOfUseWrapper>
    );
};

TermsOfUse.propTypes = {
    terms: PropTypes.string.isRequired,
    startDownload: PropTypes.func.isRequired,
    setDocTermsStorage: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
};

export default TermsOfUse;
